import Interval from './';
import { moment } from 'omni-common-ui';
import is from 'is_js';

export const create = (data) => {
  const parsedData = {
    start: data.start || data.startDate,
    end: data.end || data.endDate,
  };

  return new Interval(parsedData)
    .update('start', (start) => updateValue(start))
    .update('end', (end) => updateValue(end));
};

export default create;

function updateValue(value) {
  if (is.undefined(value)) {
    return undefined;
  }
  // the backend returns UTC timestamps
  return moment.utc(value);
}



// WEBPACK FOOTER //
// ./domain/Interval/create.js